import store from '../../../core/store';

export const listCompanyBenefits = () => {
  return store.dispatch({
    action: 'table.company_benefits/LIST_COMPANY_BENEFITS',
    method: 'GET',
    endpoint: '/company_benefits',
    main: true,
  });
};

export const createCompanyBenefit = (formData) => {
  return store.dispatch({
    action: 'table.company_benefits/CREATE_COMPANY_BENEFITS',
    method: 'POST',
    endpoint: '/company_benefits',
    data: formData,
  });
};

export const readCompanyBenefit = (company_benefit_id) => {
  return store.dispatch({
    action: 'table.company_benefits/READ_COMPANY_BENEFIT',
    method: 'GET',
    endpoint: '/company_benefits/' + company_benefit_id,
  });
};

export const updateCompanyBenefit = (company_benefit_id, formData) => {
  return store.dispatch({
    action: 'table.company_benefits/UPDATE_COMPANY_BENEFIT',
    method: 'PUT',
    endpoint: '/company_benefits/' + company_benefit_id,
    data: formData,
  });
};

export const deleteCompanyBenefit = (id) => {
  return store.dispatch({
    action: 'table.company_benefits/DELETE_COMPANY_BENEFITS',
    method: 'DELETE',
    endpoint: '/company_benefits/' + id,
  });
};

export const listPossibleBenefitPeriods = () => {
  return store.dispatch({
    action: 'table.company_benefits/LIST_POSSIBLE_BENEFIT_PERIODS',
    method: 'GET',
    endpoint: '/company_benefits/list_possible',
    main: true,
  });
};
